export const sessionStorageKeyDocNames = 'amr-repo-doc-name-values';
export const sessionStorageKeyDocs = 'amr-repo-docs-values';